export const DEFAULT_SELECTED_NETWORK_ID = process.env.VUE_APP_DEFAULT_SELECTED_NETWORK_ID ?? '';
